import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicShoppingCartFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10.68 1.81a1 1 0 01-.07.35l1.33 3.2h-1.58L9.28 2.73a1 1 0 111.4-.93zM5.64 5.35l1.07-2.61a1 1 0 10-1.32-.58l-1.33 3.2h1.58zm-3.68.52h12.07c.53 0 .97.43.97.97v1.24c0 .53-.44.97-.97.97h-.34l-.43 4.64a1.3 1.3 0 01-.23.49c-.12.15-.26.28-.42.38a2.11 2.11 0 01-1.19.34H4.58a2.24 2.24 0 01-1.18-.34c-.16-.1-.3-.23-.42-.38s-.2-.31-.24-.5L2.3 9.06h-.34A.97.97 0 011 8.08V6.84c0-.54.44-.97.97-.97zm7.91 6.85a.28.28 0 00.28.3h.58c.14 0 .26-.1.28-.23l.48-3.15a.28.28 0 00-.28-.32h-.8a.28.28 0 00-.28.26l-.26 3.14zm-2.47.04c0 .15.13.27.28.27h.64c.15 0 .28-.12.28-.27l.12-3.15a.28.28 0 00-.28-.3h-.88a.28.28 0 00-.28.3l.12 3.15zm-2.4.03c.01.14.13.24.27.24h.58a.28.28 0 00.28-.3l-.25-3.15a.28.28 0 00-.28-.25h-.8a.28.28 0 00-.29.31L5 12.8z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicShoppingCartFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicShoppingCartFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicShoppingCartFilled svgRef={ref} {...props} />
));
export default ForwardRef;
